import { MotifTooltip } from "@ey-xd/motif-react";

interface CommonTooltipWrapperProps {
  children: React.ReactNode;
  tooltipTitle: string;
  placement?: "right" | "left" | "top" | "auto" | "bottom" | undefined;
  variant?: "alt" | "default" | undefined;
  hide?: boolean;
}

const CommonTooltipWrapper: React.FC<CommonTooltipWrapperProps> = ({
  children,
  tooltipTitle,
  placement,
  variant,
  hide,
}) => {
  return (
    <MotifTooltip
      placement={placement ? placement : "right"}
      hideCloseButton
      allowHover
      allowClick={false}
      trigger={children}
      variant={variant}
      hide={hide}
    >
      {tooltipTitle}
    </MotifTooltip>
  );
};

export default CommonTooltipWrapper;
